import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StackedChartComponent } from './stacked-chart.component';

@NgModule({
  declarations: [
    StackedChartComponent
  ],
  exports: [
    StackedChartComponent
  ],
  imports: [
    CommonModule,
  ]
})
export class StackedChartModule { }
